(function() {
'use strict';

angular
    .module('transfers')
    .controller('TransferSearch', TransferSearch);

function TransferSearch($scope, $location, transferSearch, $routeParams, basketService, tripService, resourceService, broker, occupancyService, analytics) {
    const cm = this;

    $scope.$emit('block', {
        title: resourceService.get('SEARCHINGTRANSFERS'),
        subtitle: resourceService.get('THISMAYTAKE'),
        loadingScreenStyle: 'default-transferSearchCtrl'
    });

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        const transferRq = trip && trip.TransfersRequest;

        if (transferRq) {
            const searchId = transferRq.AvailabilitySearchId;

            transferSearch.getSearchResults(searchId, trip.TripId).then(function(data) {
                    cm.transfers = data;
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }, function() {
                    $location.path('transfers');
                });

            tripService.getTransfersRequestSummary($routeParams.tripId)
                .then(summary => cm.summary = summary);

            cm.getPricePP = function(totalPrice) {
                const numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
                return totalPrice / numPassengers;
            };

            analytics.track('mixpanel', 'TransferPage');

            cm.selectTransfer = function(transfer) {
                const data = {
                    Title: transfer.Type,
                    CostPP: transfer.PerPersonPrice,
                    CostTotal: transfer.TotalPrice,
                    TotalOptions: cm.transfers.length,
                    MinOptionCostTotal: _.first(cm.transfers).TotalPrice,
                    MaxOptionCostTotal: _.last(cm.transfers).TotalPrice,
                    SupplierName: transfer.SupplierName
                };
                analytics.track('mixpanel', 'OptionsTransferSelected', data);
                basketService.selectTransfer(transfer.TransferId, searchId, trip.BasketId, trip.TripId);
                cm.selectedTransfer = transfer.TransferId;
            };

        }
    });
}
})();
